import { render, staticRenderFns } from "./MLsportCartNew.vue?vue&type=template&id=46df9ef8&scoped=true"
import script from "./MLsportCartNew.vue?vue&type=script&lang=js"
export * from "./MLsportCartNew.vue?vue&type=script&lang=js"
import style0 from "./MLsportCartNew.vue?vue&type=style&index=0&id=46df9ef8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46df9ef8",
  null
  
)

export default component.exports